export function slugify(text: string | null | undefined): string {
  return (text ?? "").toLowerCase().replace(/\s+/g, "-").replace(/[^a-z0-9-]/g, "");
}

export function doctorUrl(department: string, practitionerName: string): string {
  return `/doctors/${slugify(department)}/${slugify(practitionerName)}`;
}

export function departmentUrl(name: string): string {
  return `/departments/${name}`;
}
